import React from "react"
import { usePaletteTheme } from "../../context/paletteTheme"
import { useLocation } from "react-router-dom"
import useUser from '../../hooks/useUser'
import { Button, Tabs, Tab, useMediaQuery, AppBar, Toolbar, Container } from '@mui/material'
import history from '../../history'
import Avatar from './Avatar'
// import LogoIcon from '../LogoIcon'
import SubLogoIcon from '../SubLogoIcon'
import FeedSearchModal from "../dashboardComponents/components/FeedSearchModal"
import ThemeSwitcherButton from './ThemeSwitcherButton'
import { Search } from '@mui/icons-material'
import styles from './Header.module.scss'
import { useGeneral } from '../../context/general'


export default function Header() {
  const { isLoggedIn } = useUser()
  const { checked } = usePaletteTheme()

  return (
    <AppBar position="sticky" className={styles['header']}>
      <Container maxWidth="xl" className={styles['full-height']}>
        <Toolbar className={styles['full-height']} disableGutters>
          <div style={{width:'100%', display:'flex',justifyContent:'flex-start'}}>
            <div>          
              {/* <LogoIcon isLightMode={checked}/> */}
              {/* <SubLogoIcon isLightMode={checked}/> */}
              <SubLogoIcon />
            </div>
            {isLoggedIn ? <LoggedInHeader/> : <div className={`${styles['header-content']} ${styles['login']}`}><ThemeSwitcherButton/></div>}
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

const LoggedInHeader = () => {
  const location = useLocation()
  // const navigate = useNavigate();
  const smallScreen = useMediaQuery(theme => theme.breakpoints.down('md'))

  const { handleCreateProjectAndOpen, setprojectTickerData, tickers, projects } = useGeneral()
  const [LatestProjectId, setLatestProjectID ] = React.useState(null)
  const [ticker, setTicker] = React.useState('')

  React.useEffect(()=>{
    if (tickers?.length>0){
      setTicker(tickers[0].value)
      setprojectTickerData(tickers[0])
    }
    return () => {}
  },[tickers])
  

  React.useEffect(()=>{
    if (projects?.length>0){
      setLatestProjectID(projects[0].uuid)
    }
    else{
      setLatestProjectID(null)
    }
    return () => {
      setprojectTickerData(null)
    }
  },[projects])

  const tabs = [
    { label: 'Dashboard', paths: ['/', '/dashboard'],newWindow: false },
    { label: "Single Stock Analysis", paths: [`/visualization`] ,newWindow: false},
    { label: 'Multi Stocks Analysis', paths: ['/multistocks'] ,newWindow: false},
    { label: 'EDA-Dashboard', paths: ['/EDA-Dashboard'] ,newWindow: false},
    // { label: 'Studio', paths: ['/studio'] ,newWindow: false},
    { label: 'Watchlist', paths: ['/watchlist'] ,newWindow: false},
    { label: 'Screener', paths: ['/screener'] ,newWindow: false},
    { label: 'Quant Lab', paths: ['https://lab360.althub.com/'], newWindow: true},
  ]


  // const currentTab = tabs.find(route => route.paths.includes(location.pathname.toLowerCase()))

  // Extracting the pathname and search from the location for dynamic matching
  const currentPath = location.pathname + location.search;
  
  // Match current tab based on dynamic paths
  const currentTab = tabs.find((tab) =>
    tab.paths.some((path) => {
      if (path === "/visualization") {
        return currentPath.startsWith(path);
      }
      return currentPath === path;
    })
  );


  const handleHref = (tab) =>{
    if (tab.label == 'Single Stock Analysis'){
      return `/visualization?projectId=${LatestProjectId}`
    }
    else{
      return tab.paths[0]
    }
  }


  const handleTabClick = (event, tab) => {
    // Allow default behavior for right-click and middle-click
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }
  
    event.preventDefault(); // Prevent full reload on left-click
    const path = tab.label === 'Single Stock Analysis' 
      ? `/visualization?projectId=${LatestProjectId}`
      : tab.paths[0];
    
    if (tab.label == "Quant Lab"){
      window.open(tab.paths[0], '_blank')
    }
    else{
    history.push(path); // Use React Router navigation
    }
  };  

  return (
    <div className={styles['header-content']} style={{width:'60%'}}>

      <Tabs 
          value={currentTab?.paths[0] || false} 
          className={styles['full-height']} 
          classes={{ indicator: styles['indicator'] }}
          variant="scrollable" 
          scrollButtons={true}
          allowScrollButtonsMobile
          sx={{
            '& .MuiTabs-scrollButtons': {
              color: 'var(--textPrimary)', // change to any color
            },
            // '& .MuiTabs-scrollButtons.Mui-disabled': {
            //   opacity: 0.3, // optional: style disabled state
            // },
          }}

      >
          {tabs.map(tab => (
            <Tab
              component="a"
              href={handleHref(tab)} // Enables right-click "Open in New Tab"
              label={tab.label}
              value={tab.paths[0]}
              onClick={(event) => handleTabClick(event, tab)} // Prevents full reload on left-click
              classes={{ root: styles['tab'], selected: styles['selected'] }}
              key={tab.paths[0]}
            />
          ))}
      </Tabs>

        <div className={styles['items-end']}>
          <Avatar />
          <ThemeSwitcherButton/>
          { !smallScreen && (
              <div className={styles['search']}>
                <FeedSearchModal Type="Header">
                  <Button startIcon={<Search/>} variant="contained" size='small' color='secondary' classes={{root: styles['search-button']}}> Search</Button>
                </FeedSearchModal>
              </div>
          )}
        </div>
      </div>
  )
}
